// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html, body {\n  width: 100%;\n  background-color: #f0f4f5;\n}\n\nbody {\n  display: table;\n}\n\n.auth-pages__Main__container__3PWVq {\n  background-color: #f0f4f5;\n  font-family: 'Helvetica Neue', Helvetica;\n}\n\n@media (max-width: 480px) {\n  html, body {\n    background-color: #fff;\n  }\n\n  .auth-pages__Main__container__3PWVq {\n    background-color: #fff;\n    height: 100%;\n    padding-top: 0;\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"container": "auth-pages__Main__container__3PWVq"
};
module.exports = exports;
